import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import React, { useContext, useEffect } from 'react';
import {
	IEditModifierGroupContext,
	EditModifierGroupContext,
} from '../../../../editModifierGroupState/editModifierGroupContext';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import { NameModifierGroupInput } from './components/NameModifierGroupInput';
import { ExternalIdField } from './components/ExternalIdField';
import { ArticleNumberField } from './components/ArticleNumberField';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';
import { BtnBlock } from './components/BtnBlock';
import { Form } from 'antd';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		changeLoaderStatus,
		changeNameOfModifierGroup,
		changeExternalId,
		generateUniqueExternalId,
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		isLoading,
		modifierGroupID,
		IDSelectedCustomer,
		initialIDSelectedCustomer,
		IDsSelectedRestaurant,
		initialIDsSelectedRestaurant,
		nameOfModifierGroup,
		externalId,
		articleNumber,
		translations,
		defaultCustomerLanguage,
		selectedTranslationTab,
	} = useContext<IEditModifierGroupContext>(EditModifierGroupContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedCustomer,
			IDsSelectedRestaurant,
			nameOfModifierGroup,
			externalId,
			articleNumber,
		});
	}, [IDSelectedCustomer, IDsSelectedRestaurant, nameOfModifierGroup, externalId, articleNumber]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			id: modifierGroupID,
			name: nameOfModifierGroup,
			articleNumber: articleNumber || '',
			externalId: externalId || '',
			translations: translations.map((translation) => ({
				languageId: translation.languageId,
				name: translation.name || '',
			})),
			restaurantIds: IDsSelectedRestaurant,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<div className={style.infoWrapper}>
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#circleInfoTransparent`} />
						</svg>
						<Text
							translationNameSpace="form"
							translationKey="warningBeforeModifierGroupChange"
							theme="secondary"
							size="s"
							display="inline"
						/>
					</div>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<NameModifierGroupInput changeNameOfModifierGroup={changeNameOfModifierGroup} />
					<div className={style.row}>
						<CustomerSelect
							setIDCustomer={setIDCustomer}
							setFetchedCustomers={setFetchedCustomers}
							initialIDSelectedCustomer={initialIDSelectedCustomer}
						/>
						<ArticleNumberField />
					</div>
					<div className={style.row}>
						<ExternalIdField changeExternalId={changeExternalId} />
						<Button onClick={generateUniqueExternalId} theme="primary">
							<Text
								translationNameSpace="form"
								translationKey="generateUniqueExternalId"
								asFragment={true}
							/>
						</Button>
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<MenuTranslationForm
						className={style.translationForm}
						setDefaultCustomerLanguage={setDefaultCustomerLanguage}
						setTranslationTab={setTranslationTab}
						changeNameTranslation={changeNameTranslation}
						isShowLanguageName={false}
						IDSelectedCustomer={IDSelectedCustomer}
						translations={translations}
						selectedTranslationTab={selectedTranslationTab}
						nameLabel="nameLabel"
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantListHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<RestaurantsMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						changeLoaderStatus={changeLoaderStatus}
						IDSelectedCustomer={IDSelectedCustomer}
						initialIDsSelectedRestaurant={initialIDsSelectedRestaurant}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				{!isLoading && <BtnBlock changeTypeOfModalWindow={changeTypeOfModalWindow} />}
			</Form>
		</div>
	);
};
